// extracted by mini-css-extract-plugin
module.exports =  {"header":"adQUlgpJ","subheading":"qMUDLBy2"};